// import '../reset.css';

const ExternalWebsite = ({ url }: any) => {
  const handleLinkClick = (event: any) => {
    // if(event.target.href && !event.target.href.includes('#')){
    //   window.location.href = event.target.href;
    // } 
  };
  return (
    <div style={{ height: '100vh', overflow: 'hidden', margin: 0, padding: 0 }}>
      <iframe
        src={url}
        title="External Website"
        width="100%"
        height="100%"
        style={{ border: 'none' }}
        sandbox="allow-same-origin allow-scripts allow-popups"
        onLoad={() => {
          const iframeDocument = document.querySelector('iframe')?.contentDocument;
          if (iframeDocument) {
            const links = iframeDocument.querySelectorAll('a');
            links.forEach(link => {
              link.addEventListener('click', handleLinkClick);
            });
          }
        }}
      />
    </div>
  );
};


export default ExternalWebsite;
